import { render, staticRenderFns } from "./SelezioneMultiplaPRODAdapter.vue?vue&type=template&id=4755c78b&scoped=true&"
import script from "./SelezioneMultiplaPRODAdapter.vue?vue&type=script&lang=js&"
export * from "./SelezioneMultiplaPRODAdapter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4755c78b",
  null
  
)

export default component.exports